import * as React from 'react'
import { PeriodicMaintenanceItemProps } from './types'
import { Label } from 'ui/components/FormFields/Label'
import { Checkbox } from '../FormFields/Checkbox'
import { useFormContext } from 'react-hook-form'
import { Controller } from 'react-hook-form'

const CheckboxComponent = ({ title, description, name, htmlDescription }: PeriodicMaintenanceItemProps) => {
    const formContext = useFormContext()
    const fieldState = formContext?.getFieldState(name)

    return (
        <>
            <div className="items-top bg-brand-grey050 relative flex space-x-4 p-4">
                <Controller
                    control={formContext.control}
                    name={name}
                    render={({ field: { onChange, value, ref } }) => (
                        <Checkbox id={name} checked={value} onCheckedChange={onChange} ref={ref} />
                    )}
                />
                <span className="peer-aria-checked:bg-brand-red left:0 absolute inset-x-0 top-0 !ml-0 h-1 bg-black" />
                <div className="flex flex-col">
                    <Label
                        htmlFor={name}
                        className="!mb-0 hover:cursor-pointer peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
                    >
                        {title}
                    </Label>
                    {description && <p className="text-grey800 mt-2 text-xs">{description}</p>}
                    {htmlDescription && (
                        <div
                            className="text-grey800 mt-2 text-xs"
                            dangerouslySetInnerHTML={{ __html: String(htmlDescription) }}
                        />
                    )}
                </div>
            </div>
            {fieldState?.invalid && <p className="error text-brand-red pt-1">{fieldState?.error?.message}</p>}
        </>
    )
}

export default CheckboxComponent
